<template>
    <div class="az-form-content" style="padding-left: 0; padding-right: 0">
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex v-if="!visualizando" xs12 sm12 d-flex class="pb-0 mb-0">
                    <edl-file-upload height="80px" :accept="arquivosAceitos" :repository="repository" ref="azFileUploadRecursoContrarrazao">
                        <a @click.prevent="$refs.azFileUploadRecursoContrarrazao.openFileSelector()">
                            <v-icon>archive</v-icon>
                            Importar Arquivos
                        </a>
                    </edl-file-upload>
                </v-flex>
                <v-flex xs12 sm12 d-flex class="py-0 my-0">
                    <v-data-table v-if="dadosRecursoContrarrazao.anexos && dadosRecursoContrarrazao.anexos.length > 0"
                                  :headers="colunasTabelaAnexos"
                                  :items="dadosRecursoContrarrazao.anexos"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list">
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                  <v-icon size="20">description</v-icon> {{ props.item.nome }}
                                </td>
                                <td class="table-actions">
                                    <div>
                                        <a :href="criarLinkDownloadTemporario(props.item.uri)" target="_blank"
                                           class="az-action-link-icon">
                                            <v-icon>get_app</v-icon>
                                        </a>
                                        <a v-if="!visualizando" @click.prevent="removerAnexo(props.item)">
                                            <v-icon>close</v-icon>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <az-confirm @onConfirm="remover(); mostrarDialogRemoverArquivo = false;"
                    @onDecline="mostrarDialogRemoverArquivo = false"
                    v-if="mostrarDialogRemoverArquivo">
            Tem certeza que deseja remover o anexo?
        </az-confirm>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";

export default {
    name: 'LicitacaoRecursoContrarrazaoAnexo',
    components: {EdlFileUpload},
    props: {
        visualizando:{
          type: Boolean,
          default: false
        },
        dadosRecursoContrarrazao: {
          type: Object,
          default: () => {}
        },
        tipo: {
            type: String,
            default: 'fornecedor'
        }
    },
    data() {
        return {
          colunasTabelaAnexos: [
                {
                    text: 'Nome',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '120px'
                }
            ],
            licitacaoId: undefined,
            mostrarDialogRemoverArquivo: false,
            propostaDocumentoIdRemocao: undefined,
            idAnexoRemocao: null
        }
    },
    computed: {
        repository() {
            return `repo1:licitacao/${this.licitacaoId}/${this.tipo}/${this.loki.user.id}`
        },
        arquivosAceitos() {
            return this.parametros.propriedadesLicitacao.extensao
        },
        ...mapState(['loki', 'parametros'])
    },
    created() {
        this.desabilitarLoadingGlobal()
    },
    async mounted() {
        this.resetUploadedFiles()
        this.licitacaoId = this.$route.params.id
    },
    watch: {
        'loki.uploadedFiles': {
            async handler() {
                if (this.isUploadArquivosTemporariosCompleto()) {
                    await this.inserir()
                }
            }
        }
    },
    methods: {
        removerAnexo(anexo) {
            this.anexoRemocao = anexo
            this.mostrarDialogRemoverArquivo = true
        },
        isUploadEmAndamento() {
            const arquivosEmProgresso = this.loki.uploadFileProgress
            const numeroArquivosEmProgresso = Object.keys(arquivosEmProgresso).length
            if (!numeroArquivosEmProgresso) {
                return false
            }
            let isEmAndamento = false
            Object.keys(arquivosEmProgresso).forEach(chaveArquivo => {
                const arquivo = arquivosEmProgresso[chaveArquivo]
                if (!arquivo.error) {
                    isEmAndamento = true
                }
            })
            return isEmAndamento
        },
        isUploadArquivosTemporariosCompleto() {
            return !this.isUploadEmAndamento() && this.loki.uploadedFiles.length > 0
        },
        async inserir() {
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Salvando anexos...')
            try {
                this.mostrarDialogConfirmarSaida = false
                this.atualizarListaAnexos()
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoSucessoDefault()
            } catch (e) {
                this.desabilitarLoadingGlobal()
            }
        },
        atualizarListaAnexos() {
            const anexos = []
            this.loki.uploadedFiles.forEach(item => {
                anexos.push({
                  nome: item.name,
                  status: item.status,
                  uri: item.uri,
                  url: item.url
                })
            })
            this.dadosRecursoContrarrazao.anexos = anexos
        },
        async remover() {
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Removendo anexo...')
            try {
                const anexoRemocao = {
                  name: this.anexoRemocao.nome,
                  status: this.anexoRemocao.status,
                  uri: this.anexoRemocao.uri,
                  url: this.anexoRemocao.url
                }
                this.setUploadedFiles(this.loki.uploadedFiles.filter(item => !_.isEqual(item, anexoRemocao)))
                this.atualizarListaAnexos()
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoSucessoDefault()
            } catch (e) {
                this.desabilitarLoadingGlobal()
            }
        },
    }
}
</script>
